package bootstrap

import kotlinx.css.*
import kotlinx.css.properties.Timing
import kotlinx.css.properties.s
import kotlinx.css.properties.transition
import kotlinx.html.classes
import kotlinx.html.js.onClickFunction
import org.w3c.dom.events.Event
import react.Props
import react.dom.a
import react.dom.i
import react.dom.jsStyle
import react.fc
import styled.StyleSheet
import styled.css
import styled.styledI

private object ComponentStyles : StyleSheet("IconButton") {
    val icBtn by css {
        background = "transparent"
        color = rgb(52, 40, 104, 0.4)
        padding(0.5.rem)
        borderRadius = 50.pct
        transition("all", 0.4.s, Timing.ease)
        hover {
            backgroundColor = rgb(52, 40, 104, 0.8)
            color = Color.white
        }
    }
    val icDisabledBtn by css(icBtn) {
        color = Color.lightGray
        hover {
            color = Color.lightGray
            backgroundColor = Color.transparent
        }
    }
    val icDangerBtn by css(icBtn) {
        hover {
            backgroundColor = Color("#e76c90")
        }
    }
    val icSuccessBtn by css(icBtn) {
        hover {
            backgroundColor = Color("#5cb85c")
        }
    }
}

enum class IconButtonType {
    Default,
    Danger,
    Success
}

external interface IconButtonProps : Props {
    var href: String
    var icon: String
    var disabled: Boolean
    var type: IconButtonType
    var onClickFunction: (e: kotlinx.html.org.w3c.dom.events.Event) -> Unit
    var weight: Number
}
val iconButton = fc<IconButtonProps> { props ->
    a(if (undefined != props.href) props.href else "#", classes = "mr-1 ml-1") {
        attrs.onClickFunction = {
            if (undefined == props.href) {
                it.preventDefault()
                it.stopPropagation()
                if (!props.disabled) {
                    if (undefined != props.onClickFunction)
                        props.onClickFunction(it)
                }
            }
        }
        styledI {
            attrs.classes = attrs.classes.plus(props.icon)
            css {
                if (!props.disabled) {
                    +when (props.type) {
                        IconButtonType.Danger -> ComponentStyles.icDangerBtn
                        IconButtonType.Success -> ComponentStyles.icSuccessBtn
                        else -> ComponentStyles.icBtn
                    }
                } else {
                    +ComponentStyles.icDisabledBtn
                }
            }
            attrs.jsStyle {
                fontSize = 1.5.rem
                if (undefined != props.weight)
                    fontWeight = props.weight
            }

//            attrs.jsStyle {
//                background = "transparent"
//                color = "rgba(52, 40, 104, 0.4)"
//                fontSize = 1.6.rem
//                padding = 0.5.rem
//                borderRadius = 50.pct
//                transition = "all 0.4s ease"
//                hover = {
//                    background = if (props.danger) "rgba(52, 40, 104, 0.8)" else "#e76c90"
//                    color = "#fff"
//                }
//            }
        }
    }
}